import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NotFoundPage from '../views/page-not-found.vue';
import ListOfUsers from '../views/ListOfUsers.vue';
import ListOfSpaces from '../views/ListOfSpaces.vue';
import ListOfProjects from '../views/ListOfProjects.vue';
import Login from '../views/Login.vue'
import User from '../views/User.vue'
import Space from '../views/Space.vue'
import Project from '../views/Project.vue'
import Prototype from '../views/Prototype.vue'
import ListOfPrototypes from '../views/ListOfPrototypes.vue'
import ListOfOtfAssets from '../views/ListOfOtfAssets.vue'
import OtfAsset from '../views/OtfAsset.vue'
import Dashboard from '../views/Dashboard.vue'
import DatabaseFunctions from '../views/DatabaseFunctions.vue'
import ListOfLogs from '../views/ListOfLogs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true
  },
  {
    path: '/list_of_users',
    name: 'list_of_users',
    component: ListOfUsers
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/list_of_spaces',
    name: 'list_of_spaces',
    component: ListOfSpaces,
    props: true
  },
  {
    path: '/list_of_projects',
    name: 'list_of_projects',
    component: ListOfProjects,
    props: true
  },
  {
    path: '/list_of_otf_assets',
    name: 'list_of_otf_assets',
    component: ListOfOtfAssets,
    props: true
  },
  {
    path: '/list_of_prototypes',
    name: 'list_of_prototypes',
    component: ListOfPrototypes,
    props: true
  },
  {
    path: '/list_of_logs',
    name: 'list_of_logs',
    component: ListOfLogs,
    props: true
  },
  {
    path: '/user/:uuid',
    name: 'user',
    component: User
  },
  {
    path: '/space/:uuid',
    name: 'space',
    component: Space
  },
  {
    path: '/project/:uuid',
    name: 'project',
    component: Project
  },
  {
    path: '/prototype/:uuid',
    name: 'prototype',
    component: Prototype
  },
  {
    path: '/otf_asset/:uuid',
    name: 'otf_asset',
    component: OtfAsset
  },
  {
    path: '/database_functions',
    name: 'database_functions',
    component: DatabaseFunctions
  },
  {
    path: '*',
    name: 'pageNotFound',
    component: NotFoundPage
  }
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
